import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../context/GlobalContext";
import { v4 as uuid } from "uuid";
import { RandomStringID } from "../../../Util/RandomStringID";

import { getAccountDetails } from "../../../../api/apigeeApi";
import { convertCalendarDate, Error, prefixSelector } from "../../../Util/Util";
import Accordion from "../../../Common/Accordion/Accordion";

import './NewCustomer.scss';
import InputCustom from "../../../Common/InputCustom/InputCustom";
import { Form } from "antd";
import SelectCustom from "../../../Common/SelectCustom/SelectCustom";
import CustomCalendar from "../../../Common/CustomCalendar/CustomCalendar";
import CaptchaCustom from "../../../Common/CaptchaCustom/CaptchaCustom";
interface Props {
  rtl: boolean;
  dir?: string;
  page: string;
}

function NewCustomer({ rtl, page }: Props) {
  const [state, dispatch]: any = useContext(GlobalContext);
  const [count, setCount] = useState(0);
  const [captchaChecked, setCaptchaChecked] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [gender, setGender] = useState("male");
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { t } = useTranslation();
  const { newCustomerFieldsTouched, newCustomerData, lang, nationalities } =
    state;
  const initialValues = {
    crNumber: newCustomerData.crNumber,
    vatNumber: newCustomerData.vatNumber,
    companyName: newCustomerData.companyName,
    address: newCustomerData.address,
    title: newCustomerData.title,
    firstName: newCustomerData.firstName,
    lastName: newCustomerData.lastName,
    email: newCustomerData.email,
    mobileNumber: newCustomerData.mobileNumber,
    idNumber: newCustomerData.idNumber,
    idType: newCustomerData.idType,
    gender: newCustomerData.gender,
    idIssueDate: newCustomerData.idIssueDate,
    idExpiryDate: newCustomerData.idExpiryDate,
    Z_KUTDateofBirth: newCustomerData.Z_KUTDateofBirth,
    nationality: newCustomerData.nationality,
    prefix: newCustomerData.prefix ? newCustomerData.prefix : "966",
    additionalPrefix: newCustomerData.additionalPrefix
      ? newCustomerData.additionalPrefix
      : "966",
  };
  const dir = rtl ? "right" : "left";
  const time = new Date();
  const dateOnly = new Date().toISOString().split('T')[0];
  const ds = time
    .toISOString()
    .replace(/[^0-9]/g, "")
    .slice(0, 14);
  const randomID = RandomStringID(32, "aA#");

  const titleOptions = [
    {
      text: t("Mr"),
      value: "Mr",
    },
    {
      text: t("Mrs"),
      value: "Mrs",
    },
    {
      text: t("Miss"),
      value: "Miss",
    },
  ];
  const IDTypeOptions = [
    {
      text: t("Saudi_National_ID"),
      value: "Z128",
    },
    {
      text: t("Iqama_Number"),
      value: "Z120",
    },
  ];
  const onValuesChange = () => {
    setTimeout(() => {
      setIsFormValid(
        (newCustomerFieldsTouched ||
          form.isFieldsTouched(
            [
              "crNumber",
              "vatNumber",
              "companyName",
              "title",
              "firstName",
              "lastName",
              "email",
              "mobileNumber",
              "idNumber",
            ],
            true
          )) &&
        form.getFieldsError().every(({ errors }) => errors.length === 0)
      );
    }, 0);
  };
  const updateCustomerData = (formData: any) => {
    const {
      crNumber,
      mobileNumber,
      address,
      firstName,
      middleName,
      lastName,
      email,
      companyName,
      idNumber,
      Z_KUTDateofBirth,
      nationality,
      vatNumber,
      title,
      idType,
      idIssueDate,
      idExpiryDate,
      prefix,
      additionalPrefix,
      gender,
    } = formData;

    const newCustomerAPIRes = {
      ID: "",
      ProcessingTypeCode: "",
      Name: companyName,
      OriginTypeCode: "Z17",
      GroupCode: "",
      Status: {
        LifeCycleStatusCode: "",
        UserStatusCode: "",
      },
      ProspectParty: {
        ProspectPartyID: idNumber,
        RoleCode: "",
        LifeCycleStatusCode: "",
        RecipientPartyID: "",
        ContactParty: {
          LifeCycleStatusCode: "",
          PartyID: "",
          ContactDetails: {
            PersonFirstName: firstName,
            PersonMiddleName: middleName,
            PersonLastName: lastName,
            PersonGenderCode: gender,
            PersonFormOfAddressCode: title,
          },
        },
        ProspectDetails: {
          CompanyName: companyName,
          IndividualCustomerBirthDate: convertCalendarDate(Z_KUTDateofBirth),
          AccountIndustrialSectorCode: "Z08"
        },
        Address: {
          CountryCode: "",
          StreetPostalCode: "",
          TelephoneFormattedNumberDescription: mobileNumber,
          MobileFormattedNumberDescription: mobileNumber,
          EmailURI: email,
        },
      },
      EmployeeResponsible: {
        RecipientPartyID: "",
      },
      Item: state.productInfoAPIData,
      ZKUTOtherIndustry: "NA",
      ZDocumentType: "Z108",
      Z_Address_Building: "",
      Z_Delivery_Note_Region: " ",
      Z_ODBOperator: "",
      Z_Date_of_request: dateOnly,
      Z_Address_Street: "",
      Z_Address_District: "",
      ZKUTAdditionalNumber: "",
      ZAccountDoc_Type: "",
      Z_Address_City: "",
      ZKUTDistrictDSV2: "",
      ZCity1: "",
      Region: "",
      ZZExisitng_Flag: "",
      ZKUTStreetName: "",
      ZKUT_BuildingNumber: "",
      Z_DD_Comments: "",
      Z_Description_of_Devices: "",
      ZKUT_ProductSegment: "",
      ZAccountId_Number: crNumber,
      ZNationality: nationality,
      ZDate_ofBirth_Format: "MELADI",
      ZContactPreference: "",
      ZNo_Of_Offices: "",
      ZNo_Of_Employees: "",
      ZCustomerType: "",
      ZKUT_VATRegistrationNumber: vatNumber,
      ZKUT_CompanyIdentificationNumber: crNumber,
      ZKUT_OTPReceivednumber: mobileNumber,
      ZDoc_Type: idType,
      ZIssueDate: convertCalendarDate(idIssueDate),
      ZExpiryDate: convertCalendarDate(idExpiryDate),
      Z_KUTDateofBirth: convertCalendarDate(Z_KUTDateofBirth),
      ZODBNumber: "",
    };
    const values = {
      crNumber,
      vatNumber,
      companyName,
      address,
      title,
      firstName,
      lastName,
      email,
      mobileNumber,
      idNumber,
      idType,
      gender,
      idIssueDate,
      idExpiryDate,
      Z_KUTDateofBirth,
      nationality,
      prefix,
      additionalPrefix,
    };
    dispatch({
      type: "NEW_CUSTOMER_DATA",
      payload: {
        newCustomerAPIRes,
        values,
        page,
        customerType: "newcustomer",
        createdTime: time.toISOString(),
        uniqueId: uuid(),
        dateString: ds,
        randomID,
      },
    });
    dispatch({ type: "LOADER", payload: { loading: false } });
  };

  const getCompanyInfo = () => {
    return (
      <div>
        <InputCustom
          rtl={rtl}
          maxLength={10}
          headingleft={t("Company_Identification_Number")}
          name="crNumber"
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t("Company_Identification_Number")}`,
            },
            // { pattern: /^[1-9][0-9]*$/, message: t("Verify_entered_data") },
            { pattern: /^7\d{9}$/, message: t("Verify_entered_data") },
          ]}
          hint={t(
            "Company_Identification_Number_Example"
          )}
        />
        <InputCustom
          rtl={rtl}
          maxLength={15}
          name="vatNumber"
          headingleft={t("VAT_Registration_Number")}
          rules={[
            {
              required: true,
              message: `${t("Please_enter_a_valid_15-digit")} ${t(
                "VAT_registration_certificate"
              )}`,
            },
            { pattern: /^(([0-9]{15}){0,15})$/, message: t("Verify_VAT") },
          ]}
        />
        <InputCustom
          rtl={rtl}
          maxLength={100}
          name="companyName"
          headingleft={t("Company_Name")}
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t("Company_Name")}`,
            },
            {
              pattern: /^[\u0621-\u064A0-9a-zA-Z\s]{2,100}$/,
              message: t("Verify_entered_data"),
            },
          ]}
        />
      </div>
    );
  };

  const handleGenderByTitle = (option: string) => {
    setGender(option === "Mrs" || option === "Miss" ? "female" : "male");
  };
  const getAuthorizedPerson = () => {
    return (
      <div>
        <Typography className={`mb-2 important-text-${dir}`}>
          {t("Personal_info")}
        </Typography>
        <SelectCustom
          headingLeft={t("Title")}
          options={titleOptions}
          name="title"
          onChange={handleGenderByTitle}
        />
        <InputCustom
          rtl={rtl}
          headingleft={t("Authorized_Person_FirstName")}
          name="firstName"
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t(
                "Authorized_Person_FirstName"
              )}`,
            },
            {
              pattern: /^[\u0621-\u064Aa-zA-Z\s]{2,50}$/,
              message: t("Verify_entered_data"),
            },
          ]}
        />
        <InputCustom
          rtl={rtl}
          headingleft={t("Authorized_Person_MiddleName")}
          name="middleName"
          rules={[
            {
              pattern: /^[\u0621-\u064Aa-zA-Z\s]{2,50}$/,
              message: t("Verify_entered_data"),
            },
          ]}
        />
        <InputCustom
          rtl={rtl}
          headingleft={t("Authorized_Person_LastName")}
          name="lastName"
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t(
                "Authorized_Person_LastName"
              )}`,
            },
            {
              pattern: /^[\u0621-\u064Aa-zA-Z\s]{2,50}$/,
              message: t("Verify_entered_data"),
            },
          ]}
        />
        <Typography
          fontSize="18px"
          fontWeight="700"
          fontFamily="ScandiaWeb-Bold"
          className={`mb-2 important-text-${dir}`}
        >
          {t("Contact_info")}
        </Typography>
        <InputCustom
          rtl={rtl}
          headingleft={t("Authorized_Person_Email")}
          name="email"
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t("Authorized_Person_Email")}`,
            },
            {
              pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z.-]+\.[a-zA-Z]{2,6}$/,
              message: t("Verify_entered_data"),
            },
          ]}
        />
        <InputCustom
          rtl={rtl}
          headingleft={t("Authorized_Person_Mobile_Number")}
          prefixSelector={prefixSelector()}
          name="mobileNumber"
          maxLength={9}
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t("Authorised_MobileNo")}`,
            },
            {
              pattern: /^((5)([0-9]{8})){0,9}$/,
              message: t("Verify_entered_info"),
            },
          ]}
        />
        <Typography
          fontSize="18px"
          fontWeight="700"
          fontFamily="ScandiaWeb-Bold"
          className={`mb-2 important-text-${dir}`}
        >
          {t("ID_information")}
        </Typography>
        <SelectCustom
          rtl={rtl}
          headingLeft={t("ID_Type")}
          options={IDTypeOptions}
          onChange={() => {
            form.validateFields(["idNumber"]);
          }}
          placeholder={t("Choose_ID_Type")}
          name="idType"
        />
        <InputCustom
          rtl={rtl}
          headingleft={t("Authorized_Person_IDNumber")}
          name="idNumber"
          maxLength={10}
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t(
                "Authorized_Person_IDNumber"
              )}`,
            },
            (formInstance: any) => ({
              validator(rule: any, value: any) {
                if (value === null) {
                  return Promise.resolve();
                }
                const IDType = formInstance.getFieldValue("idType");
                if (IDType === "Z128") {
                  if (!/^1\d{9}$/.test(value)) {
                    return Promise.reject(`${t("IDNumberStartsWith")} 1`);
                  }
                } else {
                  if (!/^2\d{9}$/.test(value)) {
                    return Promise.reject(`${t("IDNumberStartsWith")} 2`);
                  }
                }
                return Promise.resolve();
              },
            }),
          ]}
        />
        <CustomCalendar
          headingLeft={t("ID_issue_date")}
          name="idIssueDate"
          maxDate={new Date()}
          lang={lang}
          rtl={rtl}
          id={"idIssueDate"}
          typeOnDropdown={true}
        />
        <CustomCalendar
          headingLeft={t("ID_expiry_date")}
          name="idExpiryDate"
          minDate={new Date()}
          lang={lang}
          rtl={rtl}
          id={"idExpiryDate"}
          typeOnDropdown={true}
        />
        <CustomCalendar
          headingLeft={t("Birthday_date")}
          name="Z_KUTDateofBirth"
          lang={lang}
          rtl={rtl}
          typeOnDropdown={true}
          id={"Z_KUTDateofBirth"}
          maxDate={new Date().setFullYear(new Date().getFullYear() - 12)}
          startDate={new Date().setFullYear(new Date().getFullYear() - 12)}
        />
        <SelectCustom
          rtl={rtl}
          headingLeft={t("Nationality")}
          options={nationalities}
          name="nationality"
        />
      </div>
    );
  };

  const onFinish = (values: any) => {
    values.gender = gender;
    setCount((prevCount) => prevCount + 1);
    if (count >= 3 && !captchaChecked) {
      Error("Captcha is Required");
      return;
    }
    dispatch({ type: "LOADER", payload: { loading: true } });
    getAccountDetails(values.crNumber).then((res: any) => {
      if (res.status === 200) {
        if (res.data.ListOfBusinessCustomer.length > 0) {
          dispatch({ type: "LOADER", payload: { loading: false } });
          window.scroll({ top: 0, left: 0, behavior: "smooth" });
          form.setFields([
            {
              name: "crNumber",
              value: values.crNumber,
              errors: [t("Process_existing_customer")],
            },
          ]);
        } else {
          updateCustomerData(values);
        }
      } else {
        const errorMsg = res.status === 401 ? res.data.fault.faultstring : "";
        Error(errorMsg || t("Unexpected_error"));
        dispatch({ type: "LOADER", payload: { loading: false } });
      }
    });
  };
  const handleCaptcha = () => {
    setCaptchaChecked(!captchaChecked);
  };
  const onFinishFailed = (errorInfo: any) => {
    const { errorFields } = errorInfo;
    if (errorFields.length > 0 && formRef.current) {
      const firstErrorField = errorFields[0].name[0]; // Get the name of the first error field
      const firstErrorFieldElement = document.getElementById(
        `${firstErrorField}`
      );
      if (firstErrorFieldElement) {
        firstErrorFieldElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  return (
    <div
      className={`newcusomter-container group-${dir}`}
      style={{ direction: rtl ? "rtl" : "ltr" }}
    >
      <Form
        ref={formRef}
        form={form}
        name="accordionForm"
        initialValues={initialValues}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onValuesChange}
      >
        <Accordion
          data={[
            {
              title: <div style={{ textAlign: dir }}>{t("Company_Info")}</div>,
              subtitle: t("Information_should_match_the_CR_Copy"),
              children: getCompanyInfo(),
            },
            {
              title: (
                <div style={{ textAlign: dir }}>
                  {t("Authorized_Person_Details")}
                </div>
              ),
              subtitle: (
                <div style={{ textAlign: dir }}>
                  {t(
                    "Information_must_match_the_AP_letter_stamped_from_chamber_of_commerce"
                  )}
                </div>
              ),
              children: getAuthorizedPerson(),
            },
          ]}
        />
        {count >= 3 && <CaptchaCustom rtl={rtl} onChange={handleCaptcha} />}
        <IconButton
          width={"130px"}
          htmlType="submit"
          rtl={rtl}
          className={`next-button ${isFormValid ? "" : "disabled"}`}
        >
          {t("Next")}
        </IconButton>
      </Form>
    </div>
  );
}

export default NewCustomer;
